<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-form
            :inline="true"
            :model="searchData"
            class="logSearch">
            <el-row>
              <el-col :span="8">
                <label class="form-tit">原咨询</label>
                <el-select
                  v-model="searchData.old_sayer"
                  class="jm-input-common"
                  clearable
                  placeholder="请选择"
                  filterable>
                  <el-option-group
                    v-for="(group, k) in ds.advisory_teacher"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="item in group"
                      :key="`${item.country}_${item.userid}`"
                      :label="item.truename"
                      :value="item.userid"/>
                  </el-option-group>
                </el-select>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">新咨询</label>
                <el-select
                  v-model="searchData.new_sayer"
                  class="jm-input-common"
                  clearable
                  placeholder="请选择"
                  filterable>
                  <el-option-group
                    v-for="(group, k) in ds.advisory_teacher"
                    :key="k"
                    :label="k">
                    <el-option
                      v-for="item in group"
                      :key="`${item.country}_${item.userid}`"
                      :label="item.truename"
                      :value="item.userid"/>
                  </el-option-group>
                </el-select>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">原国家</label>
                <jm-dict-select
                  v-model="searchData.old_country"
                  empty-value="0"
                  empty-label="请选择"
                  type="online"
                  dict-type="country"/>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">新国家</label>
                <jm-dict-select
                  v-model="searchData.new_country"
                  empty-value="0"
                  empty-label="请选择"
                  type="online"
                  dict-type="country"/>
              </el-col>
              <el-col :span="8">
                <label class="form-tit">转移时间</label>
                <el-date-picker
                  class="jm-input-common"
                  :editable="false"
                  type="daterange"
                  v-model="searchData.create_time"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  clearable
                  placeholder="请选择"/>
              </el-col>
              <!-- <el-col :span="24">
                <label class="form-tit">渠道来源</label>
                <jm-channel
                  v-model="searchData.channel"
                  clearable
                  filterable/>
              </el-col> -->
            </el-row>
            <el-form-item style="text-align: center; width:100%">
              <el-button
                type="primary"
                @click="onSearch"
                size="small">查询</el-button>
              <el-button
                type="primary"
                @click="clearSeachData"
                size="small">清空</el-button>
            </el-form-item>
          </el-form>
          <jm-tableList
            url="/index/b_i_teacher2020/fibSyncList"
            :refresh.sync="refresh"
            :search-data="searchData"
            class="adminList">
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .logSearch {
    padding: .5em 0;
  }

  .logSearch .el-col {
    margin-bottom: 10px;
  }

  .logSearch .el-col .form-tit{
    width: 100px;
    display: inline-block;
  }
</style>
<script>
import jmTableList from '@/components/data/tableList';
import student from '../student/student';
import {
  jmChannel,
  jmDictSelect
} from '@/components/tool';

export default {
  components: {
    jmTableList,
    jmChannel,
    jmDictSelect
  },
  mixins: [student],
  data() {
    let date = new Date();
    let dateNow = date.toLocaleDateString();
    let startMonth = date.getFullYear();
    dateNow = dateNow.replace(RegExp('/', 'g'), '-');
    return {
      refresh: false,
      searchData: {
        old_sayer: '',
        new_sayer: '',
        old_country: '',
        new_country: '',
        create_time: [`${startMonth}-1-1`, dateNow]
        // channel: {}
      },
    };
  },
  methods: {
    fetchData() {
      this.getDatasource();
    },
    onSearch() {
      this.refresh = true;
    },
    clearSeachData() {
      this.searchData = Object.assign({}, {
        old_sayer: '',
        new_sayer: '',
        old_country: '',
        new_country: '',
        create_time: []
        // channel: {}
      });
    }
  },
  beforeMount() {
    this.fetchData();
  },
};
</script>
